require("core-js/modules/esnext.global-this.js");
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define(["react", "react-dom"], t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).ReactNewWindow = t(e.React, e.ReactDOM);
}(this, function (e, t) {
  "use strict";

  function n(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }
  var o = n(e),
    r = n(t);
  function i(e, t) {
    for (var n = 0; n < t.length; n++) {
      var o = t[n];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }
  function c(e, t) {
    return c = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    }, c(e, t);
  }
  function s(e) {
    return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, s(e);
  }
  function u(e, t) {
    if (t && ("object" === s(t) || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e);
  }
  function l(e) {
    return l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    }, l(e);
  }
  var a,
    d,
    f,
    p,
    h = {
      exports: {}
    };
  function w(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        o = l(e);
      if (t) {
        var r = l(this).constructor;
        n = Reflect.construct(o, arguments, r);
      } else n = o.apply(this, arguments);
      return u(this, n);
    };
  }
  h.exports = function () {
    if (p) return f;
    p = 1;
    var e = d ? a : (d = 1, a = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
    function t() {}
    function n() {}
    return n.resetWarningCache = t, f = function f() {
      function o(t, n, o, r, i, c) {
        if (c !== e) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }
      function r() {
        return o;
      }
      o.isRequired = o;
      var i = {
        array: o,
        bool: o,
        func: o,
        number: o,
        object: o,
        string: o,
        symbol: o,
        any: o,
        arrayOf: r,
        element: o,
        elementType: o,
        instanceOf: r,
        node: o,
        objectOf: r,
        oneOf: r,
        oneOfType: r,
        shape: r,
        exact: r,
        checkPropTypes: n,
        resetWarningCache: t
      };
      return i.PropTypes = i, i;
    };
  }()();
  var y,
    m,
    v,
    b = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && c(e, t);
      }(u, e);
      var t,
        n,
        o,
        s = w(u);
      function u(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, u), (t = s.call(this, e)).container = null, t.window = null, t.windowCheckerInterval = null, t.released = !1, t.state = {
          mounted: !1
        }, t;
      }
      return t = u, (n = [{
        key: "render",
        value: function value() {
          return this.state.mounted ? r.default.createPortal(this.props.children, this.container) : null;
        }
      }, {
        key: "componentDidMount",
        value: function value() {
          this.window || this.container || (this.openChild(), this.setState({
            mounted: !0
          }));
        }
      }, {
        key: "openChild",
        value: function value() {
          var e,
            t = this,
            n = this.props,
            o = n.url,
            r = n.title,
            i = n.name,
            c = n.features,
            s = n.onBlock,
            u = n.onOpen,
            l = n.center;
          if ("string" != typeof l || void 0 !== c.width && void 0 !== c.height) {
            if ("parent" === l) c.left = window.top.outerWidth / 2 + window.top.screenX - c.width / 2, c.top = window.top.outerHeight / 2 + window.top.screenY - c.height / 2;else if ("screen" === l) {
              var a = void 0 !== window.screenLeft ? window.screenLeft : window.screen.left,
                d = void 0 !== window.screenTop ? window.screenTop : window.screen.top,
                f = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width,
                p = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;
              c.left = f / 2 - c.width / 2 + a, c.top = p / 2 - c.height / 2 + d;
            }
          } else console.warn("width and height window features must be present when a center prop is provided");
          if (this.window = window.open(o, i, (e = c, Object.keys(e).reduce(function (t, n) {
            var o = e[n];
            return "boolean" == typeof o ? t.push("".concat(n, "=").concat(o ? "yes" : "no")) : t.push("".concat(n, "=").concat(o)), t;
          }, []).join(","))), this.container = this.window.document.createElement("div"), this.windowCheckerInterval = setInterval(function () {
            t.window && !t.window.closed || t.release();
          }, 50), this.window) {
            if (this.window.document.title = r, this.container = this.window.document.getElementById("new-window-container"), null === this.container) this.container = this.window.document.createElement("div"), this.container.setAttribute("id", "new-window-container"), this.window.document.body.appendChild(this.container);else {
              var h = this.window.document.getElementById("new-window-container-static");
              this.window.document.body.removeChild(h);
            }
            this.props.copyStyles && setTimeout(function () {
              return e = document, n = t.window.document, o = n.createDocumentFragment(), Array.from(e.styleSheets).forEach(function (e) {
                var t;
                try {
                  t = e.cssRules;
                } catch (e) {
                  console.error(e);
                }
                if (t) {
                  var r = [];
                  Array.from(e.cssRules).forEach(function (e) {
                    var t = e.type;
                    if (t !== CSSRule.UNKNOWN_RULE) {
                      var n = "";
                      n = t === CSSRule.KEYFRAMES_RULE ? function (e) {
                        var t = ["@keyframes", e.name, "{"];
                        return Array.from(e.cssRules).forEach(function (e) {
                          t.push(e.keyText, "{", e.style.cssText, "}");
                        }), t.push("}"), t.join(" ");
                      }(e) : [CSSRule.IMPORT_RULE, CSSRule.FONT_FACE_RULE].includes(t) ? function (e) {
                        return e.cssText.split("url(").map(function (e) {
                          return "/" === e[1] ? "".concat(e.slice(0, 1)).concat(window.location.origin).concat(e.slice(1)) : e;
                        }).join("url(");
                      }(e) : e.cssText, r.push(n);
                    }
                  });
                  var i = n.createElement("style");
                  i.textContent = r.join("\n"), o.appendChild(i);
                } else if (e.href) {
                  var c = n.createElement("link");
                  c.rel = "stylesheet", c.href = e.href, o.appendChild(c);
                }
              }), void n.head.appendChild(o);
              var e, n, o;
            }, 0), "function" == typeof u && u(this.window), this.window.addEventListener("beforeunload", function () {
              return t.release();
            });
          } else "function" == typeof s ? s(null) : console.warn("A new window could not be opened. Maybe it was blocked.");
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          if (this.state.mounted && this.window) if (this.props.closeOnUnmount) this.window.close();else if (this.props.children) {
            var e = this.container.cloneNode(!0);
            e.setAttribute("id", "new-window-container-static"), this.window.document.body.appendChild(e);
          }
        }
      }, {
        key: "release",
        value: function value() {
          if (!this.released) {
            this.released = !0, clearInterval(this.windowCheckerInterval);
            var e = this.props.onUnload;
            "function" == typeof e && e(null);
          }
        }
      }]) && i(t.prototype, n), o && i(t, o), u;
    }(o.default.PureComponent);
  return v = {
    url: "",
    name: "",
    title: "",
    features: {
      width: "600px",
      height: "640px"
    },
    onBlock: null,
    onOpen: null,
    onUnload: null,
    center: "parent",
    copyStyles: !0,
    closeOnUnmount: !0
  }, (m = "defaultProps") in (y = b) ? Object.defineProperty(y, m, {
    value: v,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : y[m] = v, b.propTypes = {
    children: h.exports.node,
    url: h.exports.string,
    name: h.exports.string,
    title: h.exports.string,
    features: h.exports.object,
    onUnload: h.exports.func,
    onBlock: h.exports.func,
    onOpen: h.exports.func,
    center: h.exports.oneOf(["parent", "screen"]),
    copyStyles: h.exports.bool,
    closeOnUnmount: h.exports.bool
  }, b;
});